import Tick from "assets/svgs/tick";
import React, { useContext, useEffect, useState } from "react";
import { Accordion, Button, Form, Offcanvas } from "react-bootstrap";
import Select from "react-select";
import SaveFeedBack from "./SaveFeedBack";
import moment from "moment";
import { formDisposition, languageBarriersDisposition } from "config"; // Importing language options
import { Input, Radio } from "antd";
import { useDeleteTag, useSetTag } from "modules/nextcall/store";
import { TAG_ID } from "config";
import { toast } from "react-toastify";
import { isEmpty } from "lodash";
import secureLocalStorage from "react-secure-storage";
import { get } from "lodash";
import { useCreateTicket } from "modules/CreateTicket/store";
import { CustomerProps } from "../actionables/ShowCustomer";
import { createMeidcalEscalationTicket } from "modules/navbar/top/store";
import { DISP_FLAG } from "modules/utilities/utility";
import { DispositionComponent } from "modules/lead_Detail_pop_up/DispositionComponent";

function NewDispositionFlow({
  week,
  id,
  bookingId,
  orders,
  customerId,
  setData,
  setBooking,
  customer
}) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [responseFlag, setResponseFlag] = useState(false);
  const [unansweredFlag, setUnanswerFlag] = useState(false);
  const [shipmentAddress, setShipmentAddress] = useState({});
  const { setTagToCase } = useSetTag();
  const { deleteTagFromCase } = useDeleteTag();
  const { createTicket } = useCreateTicket();
  const {customerInfo : { gender }}  = useContext(CustomerProps);
  const { fetchNearestSlot, nearestSlot, slotDetails } = createMeidcalEscalationTicket();

  const formRow = "d-flex gap-3";
  const buttonStyle =
    "border rounded-2 mb-0 p-2 cursor-pointer option-hover flex-1 text-center";
  const selected =
    "border rounded-2 mb-0 p-2 cursor-pointer bg-primary text-white flex-1 text-center";

  const ayurvedaTreatments = [
    { label: "Minoxidil", value: "Minoxidil" },
    { label: "Gummies / Supplements", value: "Gummies / Supplements" },
    { label: "DIY - at home treatments", value: "DIY - at home treatments" },
    { label: "Transplant / PRP", value: "Transplant / PRP" },
    { label: "Others", value: "others" },
  ];

  const callResponseOptions = [
    { value: "answered", label: "Answered" },
    { value: "unanswered", label: "Not Answered" },
    { value: "languageIssue", label: "Language Issue" },
    { value: "dndMode", label: "DND Mode" },
  ];

  const checkedFlag = [
    "kitInfoFlag",
    "dosageInfoFlag",
    "breakUpTimelineExpectation",
    "minoxidilInformed",
    "appInfo",
    "herbalFlag",
    "queryInfo",
    "topical_os_informed",
    "femalePreg"
  ];

  useEffect(() => {
    setFormData({
      callResponse: null,
      languageBarrier: "", // Initialize languageBarrier in formData
      kitInfoFlag: false,
      topical_os_informed: false,
      dosageInfoFlag: false,
      healthCondition: null,
      breakUpTimeline: null,
      healthConditionComment: null,
      prevSupplementConsumed: null,
      prevSupplementComment: null,
      treatmentOtherComment: null,
      beforeTreatment: [],
      breakUpTimelineExpectation: false,
      crmMentionedTime: null,
      crmMentionedTimeComments: null,
      minoxidilInformed: false,
      appInfo: false,
      comments: null,
      herbalFlag: false,
      treatmentStart: false,
      queryInfo: false,
      interested_in_community: false,
      femalePreg:false
    });
  }, [customerId]);

  const [formData, setFormData] = useState({
    callResponse: null,
    languageBarrier: "", // Initialize languageBarrier in formData
    kitInfoFlag: false,
    topical_os_informed: false,
    dosageInfoFlag: false,
    healthCondition: null,
    breakUpTimeline: null,
    healthConditionComment: null,
    prevSupplementConsumed: null,
    prevSupplementComment: null,
    treatmentOtherComment: null,
    beforeTreatment: [],
    breakUpTimelineExpectation: false,
    crmMentionedTime: null,
    crmMentionedTimeComments: null,
    minoxidilInformed: false,
    appInfo: false,
    comments: null,
    herbalFlag: false,
    treatmentStart: false,
    queryInfo: false,
    interested_in_community: false,
    femalePreg: false
  });

  useEffect(() => {
    if (isEmpty(formData.callResponse)) {
      return;
    }
    if (!id) {
      toast.success("Mark DND Flag on lead details page");
      return;
    }
    if (formData.callResponse == "dndMode") {
      setTagToCase(id, TAG_ID);
      toast.success("Added DND Mode");
      setFormData((prevFormData) => ({
        ...prevFormData,
        dnd: true,
      }));
      setResponseFlag(true);
    } else if(responseFlag) {
      deleteTagFromCase(id, TAG_ID);
      toast.warning("Removed DND Mode");
      setFormData((prevFormData) => ({
        ...prevFormData,
        dnd: false,
      }));
      setResponseFlag(false);
    };
    const customerAddress = get(orders, [0, 'order_meta', 'shipping_address'], {});
    setShipmentAddress({
        locality: get(customerAddress, 'address1', ''),
        landmark: get(customerAddress, 'address2', ''),
        city: get(customerAddress, 'city', ''),
        state: get(customerAddress, 'province', ''),
        pincode: get(customerAddress, 'zip', '')
    })
  }, [formData.callResponse]);

  const renderedComponents = [
    { name: "callResponse", value: formData?.callResponse },
  ];

  const handleCallResponse = (response) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      callResponse: response,
      languageBarrier: response === "languageIssue" ? "" : prevFormData.languageBarrier, // Reset languageBarrier if callResponse changes
    }));
  };

  const handleLanguageBarrierChange = (value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      languageBarrier: value,
    }));
  };

  const handleCreateTticket = () => {
    const ticketPayload = {
      case_id: customerId,
      provider: null,
      current_assignment: null,
      author_id: secureLocalStorage.getItem("id"),
      action_taker: secureLocalStorage.getItem("id"),
      priority: "4",
      category: 'medical_escalations',//
      sub_category: 'pregnancy',//
      is_internal: false,
      products: [],
      total_refund_price: "0.00",
      address: shipmentAddress,
      waba: false,
      remark: "",
      source: "crm",
      source_meta: {},
      provider_meta: { due_date: null },
      comment: {},
      due_date: null,
      slotTime: nearestSlot?.slot_time
    }
    createTicket(ticketPayload);
  }

  const handleDndComment = (event) =>{
    const {value} = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      languageBarrier: value,
    }));
  }

  const handleCallResponseOnchange1 = (selectedOptions) => {
    const selectedValues = Array.from(selectedOptions).map(
      (option) => option.value
    );
    setFormData((prevFormData) => ({
      ...prevFormData,
      beforeTreatment: selectedValues,
    }));
  };

  const handleCallResponseOnchange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    if(["femalePreg"].includes(name)){
      fetchNearestSlot();
    }
    if (checkedFlag.includes(name)) {
      const value = event.target.checked;
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };

  const handleUnanswer = (event) => {
    const { value } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      script_unfullfill: value === "script_unfullfill",
      dont_want_talk: value === "dont_want_talk",
      did_not_pick_up: value === "did_not_pick_up",
      cx_wants_callBack : value === "cx_wants_callBack",
    }));
    setUnanswerFlag(true);
  };

  const required = () => (
    <span className="text-danger fw-bold fs-1 mt-2">*</span>
  );

  return (
    <div>
      <>
        <Button className="flex-1" onClick={handleShow}>
          <Tick />
        </Button>
        <Offcanvas
          show={show}
          onHide={handleClose}
          placement="end"
          style={{ width: DISP_FLAG ?"77%":"40%" , Index: 1019 }}
        >
          <Offcanvas.Body>
          <div className="d-flex gap-3">
            <div>
              {DISP_FLAG &&<DispositionComponent customer={customer} />}
            </div>
            <div>
            <div className="d-flex gap-1 flex-column">
              <div className={formRow}>
                {callResponseOptions.map((option) => (
                  <p
                    key={option.value}
                    className={
                      formData.callResponse === option.value
                        ? selected
                        : buttonStyle
                    }
                    onClick={() => handleCallResponse(option.value)}
                  >
                    <span className="fw-bold "> {option.label}</span>
                  </p>
                ))}
              </div>
              {/* <div className="my-2">
                  <Checkbox onChange={onChange}>
                    Please Select if customer want do not disturb mode. (DND
                    Mode)
                  </Checkbox>
                </div> */}
              {/* <div className="my-2">
                  <Checkbox onChange={onChange}>
                    Please Select if customer want do not disturb mode. (DND
                    Mode)
                  </Checkbox>
                </div> */}

              {/* Render the language dropdown when "Language Issue" is selected */}
              {formData?.callResponse === "languageIssue" && (
                <div className="mt-3">
                  <Form.Group controlId="formLanguageBarrier">
                    <Form.Label className="text-primary">
                      Language barrier:
                    </Form.Label>
                    <Form.Select
                      value={formData?.languageBarrier}
                      onChange={(e) =>
                        handleLanguageBarrierChange(e.target.value)
                      }
                    >
                      <option value="">Select</option>
                      {languageBarriersDisposition.map((language) => (
                        <option key={language.value} value={language.value}>
                          {language.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </div>
              )}

              {formData.callResponse === "dndMode" && (
                <div className="mt-3">
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>Please Add Comment</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      onChange={handleDndComment}
                    />
                  </Form.Group>
                </div>
              )}

              {formData?.callResponse === "answered" ? (
                <div className="d-flex flex-column gap-2 mt-2">
                  <Form.Select
                    aria-label="Default select example"
                    name="language"
                    onChange={handleCallResponseOnchange}
                    value={formData?.language}
                  >
                    <option>Please Select Language</option>
                    <option value="hindi">Hindi</option>
                    <option value="english">English</option>
                    <option value="other">Other</option>
                  </Form.Select>
                  {!formData?.language ? (
                    <div className="text-danger ms-1 my-n2">
                      Please Select Language
                    </div>
                  ) : null}

                  <Accordion className="mt-2 mb-1">
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>Medicine</Accordion.Header>
                      <Accordion.Body className="p-n3">
                        <ol className="p-n5">
                          {orders[0]?.order_meta.line_items?.map((order) => {
                            return <li className="fw-bold">{order?.name}</li>;
                          })}
                        </ol>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                  <Form.Check
                    inline
                    type="checkbox"
                    id="minoxidilCheck"
                    name="minoxidilInformed"
                    checked={formData?.minoxidilInformed}
                    onChange={handleCallResponseOnchange}
                    label={
                      <span className="fw-bold">
                        Informed the customer about minoxidil/recap hair
                        shedding ?
                      </span>
                    }
                  />
                  <Form.Check
                    inline
                    type="checkbox"
                    id="topicalCheck"
                    name="topical_os_informed"
                    checked={formData?.topical_os_informed}
                    onChange={handleCallResponseOnchange}
                    label={
                      <span className="fw-bold">
                        Explained Combined usage of topicals(oil/Serum).
                      </span>
                    }
                  />
                  {gender == "F" && <Form.Check
                    inline
                    type="checkbox"
                    id="femalePreg"
                    name="femalePreg"
                    checked={formData?.femalePreg}
                    onChange={handleCallResponseOnchange}
                    label={
                      <span className="fw-bold">
                        Is customer is pregnant ?.
                      </span>
                    }
                  />}
                  {
                    formData.femalePreg && 
                    <div className="d-flex gap-2 flex-row">
                      <Input style={{ width: '70%' }} value={nearestSlot ? moment(nearestSlot?.slot_time).format('hh:mm, MMMM Do YYYY') : '-'} />
                      <Button className="flex-1" onClick={handleCreateTticket}>
                        Create Ticket
                      </Button>
                    </div>
                  }
                  <Form.Check
                    inline
                    type="checkbox"
                    id="herbalCheck"
                    name="herbalFlag"
                    checked={formData?.herbalFlag}
                    onChange={handleCallResponseOnchange}
                    required
                    label={
                      <span className="fw-bold">
                        Inform about oral supplements safety -
                        herbal/ayurvedic.?
                      </span>
                    }
                  />
                  <div className="border p-1 rounded border-2">
                    <div className="fw-bold">
                      {required()}Explained Topicals.
                    </div>
                    <div className="mb-n2">
                      <Form.Check
                        inline
                        type="checkbox"
                        id="oralCheck"
                        name="kitInfoFlag"
                        checked={formData?.kitInfoFlag}
                        onChange={handleCallResponseOnchange}
                        required
                        label={
                          <span className="fw-bold">Explained Oral meds.</span>
                        }
                      />
                      <Form.Check
                        inline
                        type="checkbox"
                        id="dosageCheck"
                        name="dosageInfoFlag"
                        checked={formData?.dosageInfoFlag}
                        onChange={handleCallResponseOnchange}
                        required
                        label={
                          <span className="fw-bold">
                            Explained about Dosage.
                          </span>
                        }
                      />
                    </div>
                  </div>
                  <div className="border p-1 rounded border-2">
                    <label htmlFor="item1Check" className="fw-bold">
                      {required()} Do you have any health/medical conditions
                      that we should be aware of?
                    </label>
                    <div className="mt-n2">
                      <Form.Check
                        inline
                        type="radio"
                        id="healthYes"
                        label="Yes"
                        value="Yes"
                        checked={
                          formData?.healthCondition == "Yes" ? true : false
                        }
                        required
                        name="healthCondition"
                        onChange={handleCallResponseOnchange}
                      />
                      <Form.Check
                        inline
                        type="radio"
                        id="healthNo"
                        label="No"
                        value="No"
                        checked={
                          formData?.healthCondition == "No" ? true : false
                        }
                        required
                        name="healthCondition"
                        onChange={handleCallResponseOnchange}
                      />
                      {formData?.healthCondition == "Yes" ? (
                        <div className="mt-n2">
                          <Form.Group
                            className="mt-n3"
                            controlId="exampleForm.ControlTextarea1"
                          >
                            <Form.Label>Please Enter here...</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={3}
                              onChange={handleCallResponseOnchange}
                              name="healthConditionComment"
                              value={formData?.healthConditionComment}
                              placeholder="Please Enter text here..."
                            />
                          </Form.Group>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="border p-1 rounded border-2">
                    <label htmlFor="item1Check" className="fw-bold">
                      {required()} Any medicines / supplements being consumed?
                      If yes, which ones.
                    </label>
                    <div className="mt-n2">
                      <Form.Check
                        inline
                        type="radio"
                        id="medicineYes"
                        label="Yes"
                        value="Yes"
                        checked={
                          formData?.prevSupplementConsumed == "Yes"
                            ? true
                            : false
                        }
                        name="prevSupplementConsumed"
                        onChange={handleCallResponseOnchange}
                      />
                      <Form.Check
                        inline
                        type="radio"
                        id="medicineNo"
                        label="No"
                        value="No"
                        checked={
                          formData?.prevSupplementConsumed == "No"
                            ? true
                            : false
                        }
                        name="prevSupplementConsumed"
                        onChange={handleCallResponseOnchange}
                      />
                      {formData?.prevSupplementConsumed == "Yes" ? (
                        <div className="mt-n3">
                          <Form.Group
                            className=""
                            controlId="exampleForm.ControlTextarea1"
                          >
                            <Form.Label>Please Enter here...</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={3}
                              onChange={handleCallResponseOnchange}
                              name="prevSupplementComment"
                              value={formData?.prevSupplementComment}
                              placeholder="Please enter text here..."
                            />
                          </Form.Group>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div div className="border p-2 border-2 rounded">
                    <Form.Label className="fw-bold">
                      What treatments have you done for your hair/scalp before
                      starting the traya plan?
                    </Form.Label>
                    <Select
                      options={ayurvedaTreatments}
                      isMulti
                      onChange={handleCallResponseOnchange1}
                    />
                    {formData.beforeTreatment.includes("others") ? (
                      <div>
                        <Form.Group
                          className="mt-2"
                          controlId="exampleForm.ControlTextarea1"
                        >
                          <Form.Control
                            as="textarea"
                            rows={3}
                            onChange={handleCallResponseOnchange}
                            name="treatmentOtherComment"
                            placeholder="Please Enter other reason"
                          />
                        </Form.Group>
                      </div>
                    ) : null}
                  </div>
                  <div className="border p-1 rounded border-2">
                    <Form.Label className="fw-bold">
                      Explained the breakup of the timeline and set clear
                      expectations on customer goals ?
                    </Form.Label>
                    <div className="d-flex flex-row gap-3 mb-n2">
                      <Form.Check
                        inline
                        type="radio"
                        id="expectYes"
                        label="Yes"
                        value="Yes"
                        checked={
                          formData?.breakUpTimeline == "Yes" ? true : false
                        }
                        required
                        name="breakUpTimeline"
                        onChange={handleCallResponseOnchange}
                      />
                      <Form.Check
                        inline
                        type="radio"
                        id="expectNo"
                        label="No"
                        value="No"
                        checked={
                          formData?.breakUpTimeline == "No" ? true : false
                        }
                        required
                        name="breakUpTimeline"
                        onChange={handleCallResponseOnchange}
                      />
                    </div>
                  </div>
                  {/*  */}
                  <div className="border p-1 rounded border-2">
                    <label htmlFor="item1Check" className="fw-bold">
                      {required()} Any changes in CRM mentioned Timeline ?
                    </label>
                    <div className="mt-n2">
                      <Form.Check
                        inline
                        type="radio"
                        id="crmYes"
                        label="Yes"
                        value="Yes"
                        name="crmMentionedTime"
                        checked={
                          formData?.crmMentionedTime == "Yes" ? true : false
                        }
                        onChange={handleCallResponseOnchange}
                      />
                      <Form.Check
                        inline
                        type="radio"
                        id="crmNo"
                        value="No"
                        label="No"
                        checked={
                          formData?.crmMentionedTime == "No" ? true : false
                        }
                        name="crmMentionedTime"
                        onChange={handleCallResponseOnchange}
                      />
                      {formData?.crmMentionedTime == "Yes" ? (
                        <div className="mt-n3">
                          <Form.Group
                            className=""
                            controlId="exampleForm.ControlTextarea1"
                          >
                            <Form.Label>Please Enter here...</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={3}
                              onChange={handleCallResponseOnchange}
                              name="crmMentionedTimeComments"
                              value={formData?.crmMentionedTimeComments}
                              placeholder="Please Enter text here..."
                            />
                          </Form.Group>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <Form.Check
                    inline
                    type="checkbox"
                    id="appInfoCheck"
                    name="appInfo"
                    checked={formData?.appInfo}
                    onChange={handleCallResponseOnchange}
                    label={
                      <span className="fw-bold">
                        Traya app features explained and guided daily check in
                        to build a habit.
                      </span>
                    }
                  />
                  <Form.Check
                    inline
                    type="checkbox"
                    id="treatmentCheck"
                    name="treatmentStart"
                    onChange={handleCallResponseOnchange}
                    value={moment().format("YYYY-MM-DD")}
                    label={
                      <span className="fw-bold">
                        Start the treatment immediately. I am marking your start
                        date {moment().format("YYYY-MM-DD")}
                      </span>
                    }
                  />
                  <Form.Check
                    inline
                    type="checkbox"
                    id="queryCheck"
                    name="queryInfo"
                    checked={formData?.queryInfo}
                    onChange={handleCallResponseOnchange}
                    label={
                      <span className="fw-bold">
                        Remind the customer - if they have any queries further,
                        to please book a call with us. Can be done via
                        app/whatsapp.
                      </span>
                    }
                  />
                  <Form.Check
                    inline
                    type="checkbox"
                    id="comunityCheck"
                    name="interested_in_community"
                    checked={formData?.interested_in_community}
                    onChange={handleCallResponseOnchange}
                    label={
                      <span className="fw-bold">Interested in Community</span>
                    }
                  />
                  <div>
                    <Form.Group
                      className=""
                      controlId="exampleForm.ControlTextarea1"
                    >
                      <Form.Control
                        as="textarea"
                        rows={3}
                        onChange={handleCallResponseOnchange}
                        value={formData?.comments}
                        name="comments"
                        placeholder="Please Enter comment here..."
                      />
                    </Form.Group>
                  </div>
                </div>
              ) : null}
            </div>
            {formData?.callResponse === "answered" &&
            formData?.comments &&
            formData?.language &&
            formData?.crmMentionedTime &&
            formData?.healthCondition &&
            formData?.prevSupplementConsumed ? (
              <SaveFeedBack
                setShow={setShow}
                bookingId={bookingId}
                week={week}
                formData={formData}
                selected={selected}
                buttonStyle={buttonStyle}
                formRow={formRow}
                renderedComponents={renderedComponents}
                id={id}
                customerId={customerId}
                setData={setData}
                setBooking={setBooking}
              />
            ) : (
              <div className="text-danger fw-bold mt-2 text-center">
                Field with star is mandatory.
              </div>
            )}

            {formDisposition.includes(formData?.callResponse) && (
              <div className="d-flex gap-2 flex-column mt-3">
                <Radio.Group
                  className="d-flex gap-3 flex-column"
                  onChange={handleUnanswer}
                >
                  <Radio value="script_unfullfill">
                    Partially answered because not able to cover all the
                    elements of the script!
                  </Radio>
                  <Radio value="dont_want_talk">
                    Customer pickup but does not want to talk!
                  </Radio>
                  <Radio value="did_not_pick_up">
                    Customer did not pick up!
                  </Radio>
                  <Radio value="cx_wants_callBack">
                    Customer pickup but wants a call back later !
                  </Radio>
                </Radio.Group>

                {!unansweredFlag &&
                formData.callResponse === "unanswered" ? null : (
                  <SaveFeedBack
                    setShow={setShow}
                    bookingId={bookingId}
                    week={week}
                    formData={formData}
                    selected={selected}
                    buttonStyle={buttonStyle}
                    formRow={formRow}
                    renderedComponents={renderedComponents}
                    id={id}
                    customerId={customerId}
                    setData={setData}
                    setBooking={setBooking}
                  />
                )}
              </div>
            )}
            </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </>
    </div>
  );
}

export default NewDispositionFlow;
